import axios from 'axios'
import router from '@/router'
import { Message } from 'element-ui'
import { removeToken, removeUserInfo } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  // baseURL: '/api', // 使用相对路径，将通过代理访问API服务器
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  console.log('发送请求:', config.url);
  // 请求头添加token
  const token = localStorage.getItem('token')
  if (token) {
    config.headers['Authorization'] = token
  }
  
  // 将POST请求数据转换为FormData格式
  if (config.method.toLowerCase() === 'post' && config.data) {
    const formData = new FormData()
    
    // 处理普通对象
    if (typeof config.data === 'object' && !(config.data instanceof FormData)) {
      Object.keys(config.data).forEach(key => {
        // 如果是数组，需要特殊处理
        if (Array.isArray(config.data[key])) {
          // 对于数组，我们可以选择JSON字符串化或分别添加
          formData.append(key, JSON.stringify(config.data[key]))
        } else if (typeof config.data[key] === 'object' && config.data[key] !== null) {
          // 对于对象，转换为JSON字符串
          formData.append(key, JSON.stringify(config.data[key]))
        } else {
          // 普通值直接添加
          formData.append(key, config.data[key])
        }
      })
      
      // 替换原始数据
      config.data = formData
      
      // 确保Content-Type被正确设置（或由浏览器自动设置）
      delete config.headers['Content-Type'] // 让浏览器自动设置正确的Content-Type和boundary
    }
  }
  
  return config
}, error => {
  console.log('请求错误:', error)
  return Promise.reject(error)
})

// 处理登录过期的函数
const handleTokenExpired = () => {
  // 清除用户信息和token
  removeToken()
  removeUserInfo()
  
  // 提示用户
  Message({
    message: '登录已过期，请重新登录',
    type: 'warning',
    duration: 3000
  })
  
  // 跳转到登录页，并带上当前页面的路径，便于登录后跳回
  const currentPath = router.currentRoute.fullPath
  router.push({
    path: '/login',
    query: { redirect: currentPath }
  })
}

// response拦截器
service.interceptors.response.use(
  response => {
    console.log('收到响应:', response.config.url, response.data);
    
    // 开发环境模拟数据处理
    if (process.env.NODE_ENV === 'development') {
      console.log('开发模式，处理接口返回');
      
      // 使用真实数据，不再使用模拟数据
      if (response.config.url.includes('/music/index') || response.config.url.includes('/music/device')) {
        console.log('使用真实接口数据');
        return response.data; // 返回实际接口数据
      }
    }
    
    // 处理正式响应
    const res = response.data
    
    // 检查返回的数据中是否有401状态码
    if (res.status === 401) {
      console.log('接口返回401状态码，Token无效');
      handleTokenExpired()
      return Promise.reject(res.message || '登录已过期')
    }
    
    // 状态码为1表示成功
    if (res.status === 1) {
      return res
    } else {
      // 统一错误处理
      Message({
        message: res.message || '请求失败',
        type: 'error',
        duration: 3 * 1000
      })
      return Promise.reject(res.message || '网络错误')
    }
  },
  error => {
    console.log('请求错误:', error)
    
    // 针对不同错误类型进行全局处理
    let errorMessage = '网络请求失败，请稍后重试'
    
    if (error.response) {
      const status = error.response.status
      
      switch (status) {
        case 400:
          errorMessage = '请求参数错误'
          break
        case 401:
          errorMessage = '登录过期，请重新登录'
          // 401表示token无效或过期
          handleTokenExpired()
          break
        case 403:
          errorMessage = '您没有操作权限'
          break
        case 404:
          errorMessage = '请求的资源不存在'
          break
        case 500:
          errorMessage = '服务器内部错误'
          break
        default:
          errorMessage = error.response.data.message || '请求失败'
      }
    } else if (error.request) {
      // 请求发出但未收到响应
      errorMessage = '网络连接失败，请检查您的网络'
    } else {
      // 请求设置触发的错误
      errorMessage = '请求配置错误'
    }
    
    // 使用Element UI的消息提示
    Message({
      message: errorMessage,
      type: 'error',
      duration: 5 * 1000
    })
    
    return Promise.reject(error)
  }
)

export default service


// WEBPACK FOOTER //
// ./src/utils/request.js